import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MobileFriendlyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mobile_friendly"}/>
}
